var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.checkPaymentFail === true)?_c('div',[_c('ConfirmMailPayRequired')],1):_c('div',{staticClass:"row"},[(_vm.checkFreeTrial === true)?_c('PayRequired'):_c('div',{staticClass:"col-lg-12 col-md-12"},[_c('ManualDocumentContent')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }